<template v-slot:tutorial>
  <transition name="fade">
    <div v-show="isActive" class="tutorial__item">
      <div class="tutorial__image-box">
        <img
          class="tutorial__image"
          src="@/assets.app/images/tutorial-fonts.svg"
          alt=""
        />
      </div>
      <div class="tutorial__text-box">
        <h5 class="tutorial__title">Change text options</h5>
        <p class="tutorial__text">
          Here you can change the font, text size, and reading screen to just
          how you like it.
        </p>
        <div class="tutorial__btn-box">
          <a class="tutorial__btn btns" @click="bookTutorial.incrementStep()"
            >Next<span class="tutorial__btn-arr iconfont inext"></span
          ></a>
        </div>
        <ul class="tutorial__dots">
          <li class="tutorial__dot"></li>
          <li class="tutorial__dot"></li>
          <li class="tutorial__dot"></li>
          <li class="tutorial__dot"></li>
          <li class="tutorial__dot"></li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { BookTutorial, BookTutorialStep } from '@/models/doc.tutorial'

const props = defineProps<{
  bookTutorial: BookTutorial
}>()

const isActive = computed(() => {
  return props.bookTutorial.step === BookTutorialStep.fonts
})
</script>
